import { render, staticRenderFns } from "./DetailsCmp.vue?vue&type=template&id=1a6c1ad3&scoped=true"
import script from "./DetailsCmp.vue?vue&type=script&lang=js"
export * from "./DetailsCmp.vue?vue&type=script&lang=js"
import style0 from "./DetailsCmp.vue?vue&type=style&index=0&id=1a6c1ad3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6c1ad3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a6c1ad3')) {
      api.createRecord('1a6c1ad3', component.options)
    } else {
      api.reload('1a6c1ad3', component.options)
    }
    module.hot.accept("./DetailsCmp.vue?vue&type=template&id=1a6c1ad3&scoped=true", function () {
      api.rerender('1a6c1ad3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/dataPushLogs/cmp/DetailsCmp.vue"
export default component.exports